import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_LINK, WHATSAPP_DISPLAY, WHATSAPP_LINK, TAGLINE, scrollToId } from "@/constants/site";

const NAV = [
  { label: "Home", id: "home" },
  { label: "How It Works", id: "how-it-works" },
  { label: "Experiences", id: "experiences" },
  { label: "Destinations", id: "destinations" },
  { label: "About Us", id: "about" },
];

export const Footer = () => (
  <footer id="contact" data-testid="footer" className="border-t border-white/10 bg-[#08090B] px-5 pb-10 pt-16 sm:px-8 lg:px-16">
    <div className="mx-auto max-w-7xl">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Nivaan Experiences logo" className="h-10 w-10 rounded-full object-cover" />
            <div>
              <p className="font-serif text-2xl font-medium tracking-[0.35em] text-zinc-100">NIVAAN</p>
              <p className="mt-1 text-[9px] font-mono uppercase tracking-[0.4em] text-gold">Experiences</p>
            </div>
          </div>
          <p className="mt-6 max-w-xs font-serif text-lg font-light italic leading-snug text-zinc-400">{TAGLINE}</p>
        </div>
        <div>
          <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-zinc-500">Contact</p>
          <div className="mt-6 space-y-4">
            <a data-testid="footer-whatsapp" href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm font-light text-zinc-300 transition-colors hover:text-gold">
              <MessageCircle size={16} className="text-gold" /> WhatsApp: {WHATSAPP_DISPLAY}
            </a>
            <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-sm font-light text-zinc-300 transition-colors hover:text-gold">
              <Mail size={16} className="text-gold" /> {EMAIL}
            </a>
            <a data-testid="footer-instagram" href={INSTAGRAM_LINK} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm font-light text-zinc-300 transition-colors hover:text-gold">
              <Instagram size={16} className="text-gold" /> {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>
        <div>
          <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-zinc-500">Explore</p>
          <div className="mt-6 flex flex-col gap-3">
            {NAV.map((n) => (
              <button key={n.id} data-testid={`footer-link-${n.id}`} onClick={() => scrollToId(n.id)} className="w-fit text-sm font-light text-zinc-400 transition-colors hover:text-gold">
                {n.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-col items-center justify-between gap-6 border-t border-white/10 pt-8 sm:flex-row">
        <p className="text-xs font-light text-zinc-500">© 2026 Nivaan Experiences</p>
        <div className="flex items-center gap-6">
          <Link data-testid="footer-privacy-link" to="/privacy-policy" className="text-xs font-light text-zinc-500 transition-colors hover:text-gold">Privacy Policy</Link>
          <Link data-testid="footer-terms-link" to="/terms-and-conditions" className="text-xs font-light text-zinc-500 transition-colors hover:text-gold">Terms & Conditions</Link>
          <Link data-testid="footer-cancellation-link" to="/cancellation-policy" className="text-xs font-light text-zinc-500 transition-colors hover:text-gold">Cancellation Policy</Link>
        </div>
      </div>
    </div>
  </footer>
);
